import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetaxifare() {



  const cardData =
  {
    keyword: 'Pune Taxi Fare ',
    heading: 'Lotus Cab: Pune Taxi Fare ',
    headingDescription: 'Lotus Cab offers reliable and comfortable Urbania on rent in Pune services, designed to make your group or family travel smooth and stress-free. Our fleet includes well-maintained, air-conditioned Force Urbania vans — all equipped with clean interiors, spacious seating configurations and ample luggage space. Every trip is driven by a professional, background-verified chauffeur who ensures punctual pickup anywhere in Pune, courteous service, and safe, smooth driving throughout your journey. With transparent Pune Taxi Fare, flexible booking options (one-way or round-trip, local or out-station), and 24×7 customer support, Lotus Cab makes your Urbania rental in Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Lotus Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Pune Taxi Fare",
      "description": "Check updated Pune taxi fare for local, outstation, airport, and one-way trips with transparent pricing and no hidden charges. Get well-maintained sedan and SUV options, professional drivers, and flexible pickup points. Ideal for daily travel, business trips, and family rides across Pune."
    },
    {
      "name": "Pune Taxi Fare Per Km",
      "description": "Know the latest Pune taxi fare per km for sedan, SUV, and premium cab categories. Transparent per kilometer pricing with minimum base fare and clear billing structure. Perfect for local city rides and outstation travel with affordable and competitive rates."
    },
    {
      "name": "Pune Local Cab Fare",
      "description": "Affordable Pune local cab fare for hourly packages, half-day, and full-day rentals. Includes AC and non-AC options with experienced drivers and flexible pickup/drop. Ideal for shopping, office commutes, meetings, and city sightseeing."
    },
    {
      "name": "Pune Outstation Taxi Fare",
      "description": "Get accurate Pune outstation taxi fare for one-way and round trips to Mumbai, Nashik, Mahabaleshwar, Goa, and more. Transparent per km rates, driver allowance clarity, and comfortable vehicles ensure smooth long-distance travel."
    },
    {
      "name": "Pune Airport Taxi Fare",
      "description": "Check Pune airport taxi fare for pickups and drops with fixed pricing and timely service. Reliable drivers, flight tracking support, and luggage assistance make airport transfers stress-free and affordable."
    },
    {
      "name": "Pune Cab Fare Calculator",
      "description": "Use Pune cab fare calculator to estimate your trip cost instantly. Calculate fare based on distance, vehicle type, and trip duration with transparent pricing and real-time estimates for better travel planning."
    },
    {
      "name": "Pune Taxi Charges Today",
      "description": "Find updated Pune taxi charges today for local, airport, and outstation rides. Competitive pricing with no hidden fees, professional drivers, and clean vehicles for safe and comfortable journeys."
    },
    {
      "name": "Pune Sedan Fare",
      "description": "Affordable Pune sedan fare for city rides and outstation trips. AC sedan options with comfortable seating, experienced drivers, and budget-friendly per km rates ideal for individuals and small families."
    },
    {
      "name": "Pune SUV Taxi Fare",
      "description": "Check Pune SUV taxi fare for spacious and comfortable travel. Suitable for large families and group travel with premium AC vehicles, luggage space, and transparent pricing for local and outstation trips."
    },
    {
      "name": "Pune Cab Price List",
      "description": "View the complete Pune cab price list for sedan, SUV, and premium categories. Clear breakdown of per km rates, minimum charges, night charges, and driver allowance for informed booking decisions."
    },
    {
      "name": "Pune Drop Taxi Fare",
      "description": "Affordable Pune drop taxi fare for one-way trips to Mumbai, Nashik, Shirdi, and more. Pay only for one side distance with transparent pricing and professional driver support."
    },
    {
      "name": "Pune Round Trip Cab Fare",
      "description": "Get competitive Pune round trip cab fare with flexible return schedules and comfortable vehicles. Ideal for weekend getaways, pilgrimages, and business travel with transparent billing."
    },
    {
      "name": "Pune Night Taxi Charges",
      "description": "Check Pune night taxi charges with clear surcharge details and safe late-night travel options. Professional drivers and well-maintained vehicles ensure secure rides anytime."
    },
    {
      "name": "Pune AC Cab Fare",
      "description": "Affordable Pune AC cab fare for comfortable travel during all seasons. Clean air-conditioned vehicles with experienced drivers and transparent per km pricing for local and outstation rides."
    },
    {
      "name": "Pune Non AC Taxi Fare",
      "description": "Budget-friendly Pune non AC taxi fare for economical travel. Suitable for short-distance city rides and affordable outstation trips with reliable drivers and transparent rates."
    },
    {
      "name": "Affordable Taxi Fare Pune",
      "description": "Find affordable taxi fare in Pune with competitive pricing, flexible booking options, and no hidden charges. Ideal for daily commuting, airport transfers, and family trips."
    },
    {
      "name": "Best Cab Fare in Pune",
      "description": "Get the best cab fare in Pune with transparent pricing, professional drivers, and well-maintained vehicles. Suitable for corporate travel, family outings, and long-distance journeys."
    },
    {
      "name": "Pune Taxi Fare Estimate",
      "description": "Instant Pune taxi fare estimate for accurate budgeting before booking. Calculate expected cost based on distance, vehicle type, and trip duration with transparent pricing details."
    },
    {
      "name": "Pune Cab Cost Per Km",
      "description": "Know Pune cab cost per km for sedan, SUV, and premium cars with clear billing and no hidden fees. Transparent rates make planning city and outstation travel simple and convenient."
    },
    {
      "name": "Cheap Taxi Fare Pune",
      "description": "Book cheap taxi fare in Pune without compromising comfort and safety. Budget-friendly rates for local rides, airport transfers, and one-way outstation trips."
    },
    {
      "name": "Pune Taxi Fare for Family Trip",
      "description": "Special Pune taxi fare for family trips with spacious sedan and SUV options. Transparent pricing, luggage support, and professional drivers ensure safe and comfortable travel for groups."
    }
  ],
  "tableData": [
    ["Pune Taxi Fare", "Pune Taxi Fare Per Km"],
    ["Pune Local Cab Fare", "Pune Outstation Taxi Fare"],
    ["Pune Airport Taxi Fare", "Pune Cab Fare Calculator"],
    ["Pune Taxi Charges Today", "Pune Sedan Fare"],
    ["Pune SUV Taxi Fare", "Pune Cab Price List"],
    ["Pune Drop Taxi Fare", "Pune Round Trip Cab Fare"],
    ["Pune Night Taxi Charges", "Pune AC Cab Fare"],
    ["Pune Non AC Taxi Fare", "Affordable Taxi Fare Pune"],
    ["Best Cab Fare in Pune", "Pune Taxi Fare Estimate"],
    ["Pune Cab Cost Per Km", "Cheap Taxi Fare Pune"],
    ["Pune Taxi Fare for Family Trip", ""]
  ],


 "whychoose": [
    {
      "WhyChooseheading": "Pune Taxi Fare – Lotus Cab",
      "WhyChoosedescription": "Lotus Cab offers reliable and affordable Pune taxi fare services for local, airport, and outstation travel. Whether you need a sedan, SUV, or premium vehicle, we provide comfortable rides with professional drivers and transparent billing."
    },
    {
      "WhyChooseheading": "Transparent & Competitive Pricing",
      "WhyChoosedescription": "Our Pune taxi fare is calculated on a clear per-km basis with no hidden charges. Customers receive complete fare breakdown including base fare, driver allowance, and optional toll/parking charges for full transparency."
    },
    {
      "WhyChooseheading": "Accurate Fare Per KM Structure",
      "WhyChoosedescription": "Lotus Cab follows a structured per kilometer pricing model for sedan and SUV categories, making it easy to estimate your total trip cost for local rides, one-way drops, or round trips from Pune."
    },
    {
      "WhyChooseheading": "Affordable Local & Outstation Rates",
      "WhyChoosedescription": "We provide budget-friendly Pune taxi fare for city travel, airport transfers, and popular routes like Mumbai, Nashik, Mahabaleshwar, and Shirdi with flexible trip options."
    },
    {
      "WhyChooseheading": "Professional & Experienced Drivers",
      "WhyChoosedescription": "Our skilled drivers are well-trained, courteous, and familiar with Pune city routes as well as outstation highways, ensuring a safe, smooth, and punctual journey."
    },
    {
      "WhyChooseheading": "Flexible Pickup & Drop Locations",
      "WhyChoosedescription": "Lotus Cab provides convenient pickup and drop across Pune including airport, railway station, IT parks, hotels, and residential areas with on-time service."
    },
    {
      "WhyChooseheading": "Well-Maintained & Comfortable Vehicles",
      "WhyChoosedescription": "Our fleet is regularly serviced and cleaned to maintain high comfort and safety standards, ensuring a pleasant travel experience at the best taxi fare in Pune."
    },
    {
      "WhyChooseheading": "24/7 Booking & Customer Support",
      "WhyChoosedescription": "Book your Pune taxi fare anytime with our round-the-clock customer support. We assist with fare estimates, vehicle selection, and instant booking confirmation for hassle-free travel."
    }
  ]









  }

const faqData = [
  {
    question: 'Does Lotus Cab provide updated Pune taxi fare details?',
    answer: 'Yes, Lotus Cab provides transparent and updated Pune taxi fare details for local rides, airport transfers, and outstation trips with clear per km pricing and no hidden charges.',
  },
  {
    question: 'How is Pune taxi fare calculated by Lotus Cab?',
    answer: 'Pune taxi fare is calculated based on per kilometer rate, minimum base fare, trip duration, and vehicle type such as sedan or SUV. Toll and parking charges are billed separately when applicable.',
  },
  {
    question: 'What is the per km taxi fare in Pune?',
    answer: 'Lotus Cab offers competitive per km taxi fare in Pune for sedan and SUV categories. Rates vary depending on trip type (local, one-way, round trip) and vehicle selection.',
  },
  {
    question: 'Does Lotus Cab offer affordable Pune airport taxi fare?',
    answer: 'Yes, we provide fixed and affordable Pune airport taxi fare with timely pickup, professional drivers, luggage assistance, and reliable service for domestic and international transfers.',
  },
  {
    question: 'Are there separate night taxi charges in Pune?',
    answer: 'Yes, night taxi charges may apply during late hours. Lotus Cab maintains transparent pricing and informs customers about any applicable night surcharge before booking confirmation.',
  },
  {
    question: 'Can I get a Pune taxi fare estimate before booking?',
    answer: 'Absolutely. Lotus Cab provides fare estimates based on your travel distance, pickup location, and vehicle type to help you plan your budget efficiently.',
  },
  {
    question: 'Is Pune taxi fare different for one-way and round trips?',
    answer: 'Yes, one-way and round trip taxi fares differ depending on distance and duration. Lotus Cab offers competitive pricing for both drop services and return journeys from Pune.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Deshmukh',
    feedback: 'Booked Lotus Cab for Pune airport drop. The taxi fare was reasonable, and the driver arrived on time. Very smooth experience.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Joshi',
    feedback: 'Lotus Cab offers the best taxi fare in Pune. Transparent pricing and clean vehicles made our family trip comfortable and stress-free.',
    rating: 5,
  },
];




































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Taxi Fare",
  "image": "https://lotuscab.com/assets/images/pune-taxi-fare.jpg", 
  "description": "Lotus Cab offers affordable Pune taxi fare with transparent per km pricing for local, airport, outstation, sedan, SUV, AC and non-AC cab services. Get the best cab fare in Pune with professional drivers and reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-taxi-fare"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune Taxi Fare Per Km | Lotus Cab</title>
  <meta 
    name="description" 
    content="Check Pune taxi fare per km with Lotus Cab. Affordable local, airport, outstation, sedan & SUV cab fare in Pune. Get latest Pune taxi charges today. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune Taxi Fare, Pune Taxi Fare Per Km, Pune Local Cab Fare, Pune Outstation Taxi Fare, Pune Airport Taxi Fare, Pune Cab Fare Calculator, Pune Taxi Charges Today, Pune Sedan Fare, Pune SUV Taxi Fare, Pune Cab Price List, Pune Drop Taxi Fare, Pune Round Trip Cab Fare, Pune Night Taxi Charges, Pune AC Cab Fare, Pune Non AC Taxi Fare, Affordable Taxi Fare Pune, Best Cab Fare in Pune, Pune Taxi Fare Estimate, Pune Cab Cost Per Km, Cheap Taxi Fare Pune, Pune Taxi Fare for Family Trip" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetaxifare;